import React from "react";
import { Stack } from "@mui/material";

import User from "./User";
import Filter from "./Filter";
import filterIcon from "../../../../styles/svg/epic-icon.svg";
import "./../../myTask.scss";
import DrawerGlobalComp from "../../../../components/Drawer";
import { useMyTaskHeaderState } from "../../hooks/useMyTaskHeaderState";

function Header({ currentTab }) {
  const {
    isMobile,
    filterDrawer,
    shouldShowFilter,
    openFilterDrawer,
    closeFilterDrawer,
  } = useMyTaskHeaderState(currentTab);

  return (
    <div className="d-flex justify-content-space-between header-container">
      {isMobile ? (
        <div className="user-container">
          <User />
        </div>
      ) : (
        <User />
      )}
      {shouldShowFilter && (
        <>
          {isMobile ? (
            <div>
              <Stack direction="row" justifyContent={"space-between"}>
                <img
                  src={filterIcon}
                  alt="filter"
                  className="filter-icon"
                  onClick={openFilterDrawer}
                />
              </Stack>
            </div>
          ) : (
            <div className="d-flex">
              <Filter />
            </div>
          )}

          {filterDrawer && (
            <DrawerGlobalComp
              open={filterDrawer}
              setOpen={closeFilterDrawer}
              animatedWidth={330}>
              <Filter setFilterDrawer={closeFilterDrawer} />
            </DrawerGlobalComp>
          )}
        </>
      )}
    </div>
  );
}

export default Header;
